<template>
  <div class="productItem"
    :class="{
      open: item.isOpen,
      off: !item.service,
      pause: item.disabled,
      current: langValueLayer || availableLayer || manageLayer
    }"
    :style="{
      zIndex: itemZindex
    }">
    <!-- thumbnail -->
    <div class="thumb">
      <div class="thumbBtns">
        <label class="thumbBtn uploadProductImage"
          :for="`uploadProduct_${item.id}`">
          <input type="file"
            :id="`uploadProduct_${item.id}`"
            @change="uploadImage($event)">
          <img src="@/assets/img/ico_upload_image.svg" alt="" />
        </label>
        <button type="button" class="thumbBtn setLinkProduct" @click="openSetLink(item)">
          <img src="@/assets/img/ico_link.svg" alt="">
        </button>
      </div>
      <!-- 썸네일 비율/크기 -->
      <div v-if="item.thumb && prevMode === 'tablet'" class="ratioBtns">
        <label
          v-for="(r, i) in ratio"
          :key="i"
          :for="`${item.id}_ratio_${r.id}`"
          :data-ratio="`ratio_${r.id}`"
          :class="{ratioBtn: true, active: r.id === item.thumbRatio}">
          <input type="radio"
            :id="`${item.id}_ratio_${r.id}`"
            :value="r.id"
            v-model="item.thumbRatio">
            {{ r.label }}
        </label>
      </div>
      <!-- //썸네일 비율/크기 -->
      <div v-if="item.thumb"
        :style="{backgroundImage: `url('${item.thumb}')`}"
        :data-ratio="item.thumbRatio"
        alt=""
        class="thumbImg"></div>
      <img v-else src="@/assets/img/img_product_default.png" alt="" class="defaultImg">
    </div>
    <!-- //thumbnail -->
    <!-- check service -->
    <div class="checkbox chkService">
      <input type="checkbox" :id="`product_${item.id}_service`" v-model="item.service" />
      <label :for="`product_${item.id}_service`"><span class="blind">{{locale.state_public}}</span></label>
    </div>
    <!-- //check service -->
    <!-- disabled -->
    <div class="chkDisabled">
      <input type="checkbox" :id="`product_${item.id}_disabled`" v-model="item.disabled" />
      <label :for="`product_${item.id}_disabled`"><span class="blind">{{locale.pause}}</span></label>
    </div>
    <!-- //disabled -->
    <!-- delete item -->
    <button type="button" class="btnDel" @click="delItem">
      <img src="@/assets/img/ico_close_black.svg" alt="delete item" />
    </button>
    <!-- //delete item -->
    <!-- copy item -->
    <button type="button" class="btnCopy" @click="copyItem">
      <img src="@/assets/img/ico_copy_black.svg" alt="copy item" />
    </button>
    <!-- //copy item -->
    <div class="productState">
      <span class="stateItem" :class="{disabled: !isRequired.submitTo}">{{locale.submit}}</span>
      <!-- <span class="stateItem" :class="{disabled: !isRequired.thumb}">{{locale.image}}</span> -->
      <span class="stateItem" :class="{disabled: !isRequired.pName}">{{locale.name}}</span>
      <span v-if="categories && categories.length" class="stateItem" :class="{disabled: !isRequired.category}">{{locale.category}}</span>
      <span class="stateItem" :class="{disabled: !isRequired.name}">{{locale.product_name}}</span>
      <span class="stateItem" :class="{disabled: !isRequired.price}">{{locale.price}}</span>
      <span v-if="requiredSubmitCategory" class="stateItem" :class="{disabled: !isRequired.submitCategory}">{{locale.admin_submitcategory}}</span>
      <span v-if="item.manage" class="stateItem" :class="{disabled: !isRequired.manageItem}">{{locale.product_id}}</span>
      <span v-else-if="requiredPidType" class="stateItem" :class="{disabled: !isRequired.pId}">{{locale.product_id}}</span>
      <span v-if="requiredPidType" class="stateItem" :class="{disabled: !isRequired.pIdType}">{{locale.pidtype}}</span>
    </div>
    <div class="itemInfo">
      <div class="infoItem">
        <label class="label toCapitalize"><i class="colorPrimary">*</i> {{locale.name}}</label>
        <input v-model="item.info.pName" type="text" class="input">
      </div>
    </div>
    <button type="button" class="btnFold" @click="item.isOpen = !item.isOpen"><span class="blind">fold</span></button>
    <!-- product info -->
    <div class="info">
      <div class="setPrice">
        <div class="infoItem cells">
        <label class="label toCapitalize"><i class="colorPrimary">*</i> {{locale.product_price}}</label>
          <div class="pluBox">
            <input v-model="item.info.price" type="text" class="input">
            <button v-if="supportPlu" type="button" class="btnPlu" @click="setPlu">PLU</button>
          </div>
        </div>
        <div class="infoItem">
          <label class="label toCapitalize">{{locale.product_o_price}}</label>
          <input v-model="item.info.salePrice" type="text" class="input">
        </div>
      </div>
      <!-- 재고관리상품 -->
      <div class="infoItem">
        <div class="checkbox">
          <input
            type="checkbox"
            :id="`manage_${item.id}`"
            v-model="item.manage"
            @change="delManageInfo">
          <label :for="`manage_${item.id}`">{{locale.management_product}}</label>
        </div>
        <button
          v-if="item.manage"
          type="button"
          class="btn btnWhite sizeS btnFull btnSetManageProduct"
          @click="toggleManage">
          <span :class="{colorRed: outOfStock, notManaged: item.manageInfo && isManaged === false}">
            {{item.manageInfo ? item.manageInfo.inventory ? `${item.manageInfo.pId} (${item.manageInfo.qty})` : `${item.manageInfo.pId}` : locale.setting}}
          </span>
        </button>
        <p v-if="item.manage && !(item.manageInfo && item.manageInfo.pId)" class="validateMessage sysMessage">{{locale.validate_select_manage_prodcut}}</p>
        <ManageProduct
          v-if="item.manage && manageLayer"
          :locale="locale"
          :manage="item.manageInfo"
          :productItem="item.id"
          :productList="productList"
          @change="changeManage"
          @close="toggleManage" />
      </div>
      <!-- //재고관리상품 -->
      <!-- 상품설명 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.product_desc}}</label>
        <div class="translation">
          <input v-model="item.info.desc[lang.default]" type="text" class="input" @focusout="setDefaultVal('desc')">
          <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('desc')">
            <span class="blind">{{locale.language_specific_set}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
          </button>
        </div>
      </div>
      <!-- //상품설명 -->
      <!-- 상품명 -->
      <div class="infoItem">
        <label class="label toCapitalize"><i class="colorPrimary">*</i> {{locale.product_name}}</label>
        <div class="translation">
          <input v-model="item.info.name[lang.default]" type="text" class="input" @focusout="setDefaultVal('name')">
          <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('name')">
            <span class="blind">{{locale.language_specific_set}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
          </button>
        </div>
      </div>
      <!-- //상품명 -->
      <!-- 상세정보 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.product_detail}}</label>
        <div class="translation">
          <input v-model="item.info.detail[lang.default]" type="text" class="input" @focusout="setDefaultVal('detail')">
          <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('detail')">
            <span class="blind">{{locale.language_specific_set}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
          </button>
        </div>
      </div>
      <!-- //상세정보 -->
      <!-- 최소 ~ 최대 -->
      <div class="infoItem volume">
        <div class="inner">
          <label class="label toCapitalize">{{locale.min}}</label>
          <input v-model="item.info.min" type="text" class="input" @input="setQuantity(item.info, 'min')">
        </div>
        <div class="inner">
          <label class="label toCapitalize">{{locale.max}}</label>
          <input v-model="item.info.max" type="text" class="input" @input="setQuantity(item.info, 'max')">
        </div>
      </div>
      <!-- //최소 ~ 최대 -->
      <!-- 카테고리 -->
      <div v-if="categories.length" class="infoItem">
        <label class="label toCapitalize"><i class="colorPrimary">*</i> {{locale.category}}</label>
        <button type="button" class="btn btnWhite sizeS btnFull" @click="toggleCategory">{{locale.change}}</button>
      </div>
      <!-- //카테고리 -->
      <!-- 식별코드 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.product_id}}</label>
        <input v-model="item.info.pId" type="text" class="input" :disabled="item.manage">
      </div>
      <!-- //식별코드 -->
      <!-- 식별코드 타입 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.pidtype}}</label>
        <select class="input" v-model="item.info.pIdTypeId" @change="setPidType">
          <option
            v-for="pid in pIdType"
            :key="pid.id"
            :value="pid.id">
            {{pid.id === '#none' ? locale.none : pid.label}}
            </option>
        </select>
      </div>
      <!-- //식별코드타입 -->
      <!-- 프로모션 -->
      <div class="infoItem toCapitalize">
        <label class="label toCapitalize">{{locale.promotion}}</label>
        <select v-model="item.info.promotion" class="input" @change="setPromotionInfo">
          <option value="">{{ locale.none }}</option>
          <option
            v-for="(p, i) in promotion"
            :key="i"
            :value="p.id">
            {{p.default ? locale[p.id] : p.label}}
          </option>
          <!-- <option value="best">{{locale.best}}</option>
          <option value="signature">{{locale.signature}}</option>
          <option value="promotion">{{locale.promotion}}</option>
          <option value="event">{{locale.event}}</option>
          <option value="sale">{{locale.sale}}</option>
          <option value="heritage">{{locale.heritage}}</option> -->
        </select>
      </div>
      <!-- //프로모션 -->
      <!-- 전송코드 -->
      <div class="infoItem">
        <label class="label toCapitalize"><i class="colorPrimary">*</i> {{locale.submit}}</label>
        <select v-model="item.submitTo" class="input">
          <option value="">{{locale.admin_codelist}}</option>
          <option v-for="code in codeList" :key="code.id" :value="code.id">{{code.label}}</option>
        </select>
      </div>
      <!-- //전송코드 -->
      <!-- 전송카테고리 -->
      <div v-if="submitCategory && submitCategory.length" class="infoItem">
        <label class="label toCapitalize">{{locale.admin_submitcategory}}</label>
        <select v-model="item.submitCategoryId" class="input" @change="setSubmitCategory">
          <option
            v-for="cate in submitCategory"
            :key="cate.id"
            :value="cate.id">
            {{cate.id === '#none' ? locale.none : cate.label}}
            </option>
        </select>
      </div>
      <!-- //전송카테고리 -->
      <!-- 이용가능시간 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.page_set_available}}</label>
        <button type="button" class="btn btnWhite sizeS btnFull" @click="toggleAvailable">{{locale.change}}</button>
      </div>
      <!-- //이용가능시간 -->
      <!-- 처리시간 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.time_taken}}</label>
        <select v-model="item.timeTaken" class="input">
          <option value="" :selected="!item.timeTaken || item.timeTaken === ''">{{locale.not_show}}</option>
          <option v-for="(time, index) in timeTaken" :key="index" :value="index + 1">{{time}}</option>
        </select>
      </div>
      <!-- //처리시간 -->
      <!-- 픽업알림 -->
      <div class="infoItem">
        <label class="label toCapitalize">{{locale.product_pickup}}</label>
        <select v-model="item.pickup" class="input" @change="setPickupAlarm">
          <option value="" :selected="!item.pickup || item.pickup === ''">{{locale.product_pickup_none}}</option>
          <option value="auto">{{locale.product_pickup_auto}}</option>
          <option value="manual">{{locale.product_pickup_manual}}</option>
        </select>
      </div>
      <!-- //픽업알림 -->
      <!-- 픽업알림: 자동알림 시간설정 (n분 후) -->
      <div v-if="item.pickup === 'auto'" class="infoItem">
        <select v-model="item.pickupTime" class="input">
          <option v-for="time in 18" :key="time" :value="time * 5">{{getPickupTime(time)}}</option>
        </select>
      </div>
      <!-- //픽업알림: 자동알림 시간설정 (n분 후) -->
      <!-- 고객식별타입 -->
      <div v-if="hasGuestType">
        <div class="infoItem">
          <label class="label toCapitalize">{{locale.guesttype_setting}}</label>
          <button type="button" class="btn btnWhite sizeS btnFull" @click="setGuestType">{{locale.change}}</button>
        </div>
      </div>
      <!-- //고객식별타입 -->
    </div>
    <!-- //product info -->
    <!-- 카테고리 다중설정 -->
    <ProductCategory
      v-if="categoryLayer"
      :locale="locale"
      :productId="$route.params.id"
      :categories="categories"
      :checked="item.category"
      @apply="changeCategory"
      @close="toggleCategory" />
    <!-- //카테고리 다중설정 -->
    <!-- 이용시간 -->
    <AvailableTime
      v-if="availableLayer"
      :locale="locale"
      :available="item.available"
      @apply="applyAvailableTime"
      @close="setAvailableTime(false)" />
    <!-- //이용시간 -->
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :textarea="false"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- 고객식별타입 세팅 -->
    <GuestType v-if="guestTypeLayer"
      :locale="locale"
      :guestType="item.guestType"
      @apply="updateGuestType"
      @close="setGuestType" />
    <!-- //고객식별타입 세팅 -->
    <!-- PLU -->
    <Plu v-if="pluData"
      :pluData="pluData"
      :locale="locale"
      :orderType="orderType"
      @apply="applyPluData"
      @close="pluData = null" />
    <!-- //PLU -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LangValue from '@/components/Util/LangValue.vue'
import LANG from '@/common/lang'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ManageProduct from '@/components/Product/ManageProduct.vue'
import GuestType from '@/components/Util/GuestType.vue'
import AvailableTime from '@/components/Util/AvailableTime'
import ProductCategory from '@/components/Util/ProductCategory'
import Plu from '@/components/Util/Plu'

export default {
  name: 'ProductItem',
  props: [
    'locale',
    'lang',
    'productList',
    'item',
    'length',
    'zIndex',
    'productInfo',
    'category',
    'itemByCategory',
    'hasGuestType',
    'submitCategory',
    'pIdType',
    'requiredSubmitCategory',
    'requiredPidType',
    'ratio',
    'prevMode'
  ],
  components: {
    LangValue,
    ManageProduct,
    GuestType,
    AvailableTime,
    ProductCategory,
    Plu
  },
  computed: {
    ...mapGetters({
      getCode: 'admin/codeList',
      manageProduct: 'product/getManageProduct',
      getCategory: 'product/getCategory',
      getSetting: 'product/getProductSetting'
    }),
    promotion () {
      return this.getSetting && this.getSetting.promotion
    },
    orderType () {
      return this.item.submitTo && this.item.submitTo.length
        ? this.item.submitTo
        : this.productInfo.submitTo && this.productInfo.submitTo.length
          ? this.productInfo.submitTo
          : null
    },
    addedCategory () {
      return this.category.filter(x => x.id !== '')
    },
    categories () {
      const lang = this.lang.default
      const category = this.getCategory.filter(x => x.data.id !== '')
      function getCategory (arr) {
        return arr.map(x => {
          return {
            id: x.data.id,
            label: x.data.label[lang],
            ...(x.children && x.children.length) && {
              children: getCategory(x.children)
            }
          }
        })
      }
      return getCategory(category)
    },
    codeList () {
      const list = this.getCode.filter(x => x.id !== 'system_amenity')
      return list
    },
    setTime () {
      const interval = [ '00', '30' ]
      let list = []
      for (let i = 0; i <= 24; i++) {
        for (let j = 0; j < interval.length; j++) {
          list.push(`${('0' + i).slice(-2)}:${interval[j]}`)
        }
      }
      list.pop()
      return list
    },
    isManaged () {
      return this.item.manageInfo && this.manageProduct.find(x => x.pid === this.item.manageInfo.pId)
    },
    validCategoryIds () {
      const category = this.categories
      const getCategoriess = (category) => {
        if(!category.children || !category.children.length){
          return category
        }
        return [category,this._.flatMapDeep(category.children, getCategoriess)]
      }
      const flatten = this._.flatMapDeep(category, getCategoriess)
      return flatten.filter(x => !x.children).map(x => x.id)
    },
    isRequired () {
      function isBlank (str) {
        return str ? regExp.replaceAllEmpty(str).length > 0 : 0
      }
      const thumb = this.item.thumb !== ''
      const pName = isBlank(this.item.info.pName)
      const name = isBlank(this.item.info.name[this.lang.default])
      const price = isBlank(this.item.info.price)
      const submitTo = this.item.submitTo !== ''
      // const categoryChildrenIds = function (arr) {
      //   let result = []
      //   const ids = function (arr) {
      //     arr.forEach(function (x) {
      //       if (x.children && x.children.length) {
      //         ids(x.children)
      //       }
      //       return result.push(x.id)
      //     })
      //     return result
      //   }
      //   return ids(arr)
      // }
      // const allCategoryIds = function (arr) {
      //   const allIds = arr.map(x => {
      //     const childrenIds = x.children && x.children.length ? categoryChildrenIds(x.children) : []
      //     return [x.id, ...childrenIds]
      //   })
      //   return _.flatten(allIds)
      // }

      const allCategoryIds = this.validCategoryIds
      const categories = this.categories.length ? allCategoryIds : []
      const category = categories.length ? this.item.category.length && this.item.category.filter(x => categories.includes(x)).length > 0 : true
      const manageItem = this.isManaged !== false
      const pId = isBlank(this.item.info.pId)
      const pIdType = this.item.info.pIdType ? isBlank(this.item.info.pIdType.id) : false
      const submitCategory = this.item.submitCategory
      return {
        thumb: thumb,
        pName: pName,
        name: name,
        category: category,
        price: price,
        submitTo: submitTo,
        ...this.item.manage && {
          manageItem: manageItem
        },
        ...pId && this.requiredPidType && {
          pId: pId,
          pIdType: pIdType
        },
        ...submitCategory && {
          submitCategory: submitCategory
        },
        categories: categories
      }
    },
    outOfStock () {
      return this.item.manageInfo && this.item.manageInfo.qty <= 0
    },
    itemZindex () {
      const zIndex = this.zIndex
      const length = this.length
      return this.langValueLayer || this.availableLayer || this.manageLayer || this.guestTypeLayer || this.categoryLayer || this.pluData ? length + 999 : zIndex
    },
    manageInfo () {
      return this.item.manageInfo
    },
    timeTaken () {
      let result = []
      for (let i = 1; i <= 6; i++) {
        const time = i * 10
        if (i < 6) {
          result.push(`${time}${this.locale.minute}`)
        } else {
          result.push(this.locale.hour_more)
        }
      }
      return result
    },
    supportPlu () {
      return this.$store.getters['util/getSupportPlu']
    }
  },
  watch: {
    // 관리상품 레이어 토글시마다 새로운 관리상품 정보로 변경
    manageLayer () {
      if (this.isManaged) {
        const manageItem = this.isManaged
        this.changeManage(manageItem)
      }
    }
  },
  mounted () {
    if (this.isManaged) {
      const manageItem = this.isManaged
      this.changeManage(manageItem)
    }
  },
  data () {
    return {
      langValueLayer: false,
      langValue: {},
      langTarget: '',
      availableLayer: false,
      priceMessage: null,
      salePriceMessage: null,
      manageLayer: false,
      guestTypeLayer: false,
      categoryLayer: false,
      pluData: null
    }
  },
  methods: {
    openSetLink (item) {
      this.$emit('setLink', item)
    },
    onLangValueOpen (target) {
      this.langTarget = target
      this.langValueLayer = true
      this.langValue = this.item.info[target]
      this.setDefaultVal(target)
    },
    onLangValueClose () {
      const target = this.langTarget
      this.item.info[target] = this.langValue
      this.langValueLayer = false
      this.langValue = {}
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.item.info[target], this.item.info[target][defaultLang])
      this.item.info[target] = fillLangs
    },
    categoryLabel (cate) {
      return cate.id === '' ? this.locale.category : cate.label[this.lang.default]
    },
    categoryChildren (arr, id) {
      return id !== '' && arr.find(x => x.id === id) && arr.find(x => x.id === id).children
    },
    optionPrice (price) {
      const code = this.currency
      const disabledSymbol = this.$store.getters['setting/getData']?.currency?.disabledCurrencySymbol ?? false
      return price ? regExp.priceFormat(price, code, disabledSymbol) : ''
    },
    setQuantity (data, key) {
      const value = Number(regExp.numberOnly(data[key]))
      data[key] = value
      if (key === 'min') {
        data.value = value
      }
      return value
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          // this.$store.commit('tv/updateChLogo', { id: productId, logo: res.source })
          this.item.thumb = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    setAvailableTime (isOpen) {
      this.availableLayer = isOpen
    },
    applyAvailableTime (data) {
      this.item.available = data
      this.setAvailableTime(false)
    },
    setPickupAlarm () {
      if (this.item.pickup === 'auto' && !this.item.pickupTime) {
        this.item.pickupTime = 30
      }
    },
    getPickupTime (time) {
      const num = time * 5
      const message = this.locale.product_pickup_auto_after
      return message.replace('{var}', num)
    },
    delManageInfo () {
      const isChecked = this.item.manage
      if (!isChecked) {
        this.$emit('delManageInfo', this.item.id)
      }
    },
    setPromotionInfo () {
      const promotion = this.promotion && this.promotion.find(x => x.id === this.item.info.promotion)
      const isDefault = promotion.default
      const data = {
        promotionCustom: !isDefault,
        promotionIcon: isDefault ? null : promotion.icon,
        promotionSize: isDefault ? null : promotion.size
      }
      this.item.info = {
        ...this.item.info,
        ...data
      }
    },
    setPidType () {
      const id = this.item.info.pIdTypeId
      this.item.info.pIdType = this.pIdType.find(x => x.id === id)
    },
    setSubmitCategory () {
      const id = this.item.submitCategoryId
      this.item.submitCategory = this.submitCategory.find(x => x.id === id)
    },
    toggleManage () {
      this.manageLayer = !this.manageLayer
    },
    toggleAvailable () {
      this.availableLayer = !this.availableLayer
    },
    toggleCategory () {
      this.categoryLayer = !this.categoryLayer
    },
    changeCategory (ids) {
      this.item.category = ids
      // this.toggleCategory()
    },
    setGuestType () {
      this.guestTypeLayer = !this.guestTypeLayer
    },
    updateGuestType (guestType) {
      this.item.guestType = guestType
    },
    validatePrice (e) {
      const value = e.target.value
      const price = Number(value)
      if (value.length) {
        if (price <= 0) {
          this.priceMessage = this.locale.validate_lt_0
        } else if (value.length && isNaN(price)) {
          this.priceMessage = this.locale.validate_number_only
        } else {
          this.priceMessage = null
        }
      } else {
        this.priceMessage = null
      }
    },
    validateSalePrice (e) {
      const value = e.target.value
      const oPrice = Number(this.item.info.price)
      const price = Number(value)
      if (value.length) {
        if (oPrice >= price) {
          this.salePriceMessage = this.locale.validate_price_lt_saleprice
        } else if (price <= 0) {
          this.salePriceMessage = this.locale.validate_lt_0
        } else if (isNaN(price)) {
          this.salePriceMessage = this.locale.validate_number_only
        } else {
          this.salePriceMessage = null
        }
      } else {
        this.salePriceMessage = null
      }
    },
    changeManage (manageItem) {
      const updateManageItem = {
        id: this.item.id,
        data: {
          pId: manageItem.pid,
          qty: manageItem.qty,
          ...manageItem.pname && {
            pName: manageItem.pname
          },
          inventory: manageItem.inventory
        }
      }
      this.$emit('updateManage', updateManageItem)
    },
    delItem () {
      if (window.confirm(this.locale.confirm_delete_product)) {
        this.$emit('delete', this.item.id)
      }
    },
    copyItem () {
      if (window.confirm(this.locale.confirm_copy_product)) {
        this.$emit('copy', this.item.id)
      }
    },
    setPlu () {
      this.pluData = this.item.info
    },
    applyPluData (data) {
      this.item.info = {
        ...data,
        name: data.label,
        pName: data.value
      }
      this.pluData = null
    }
  }
}
</script>

<style lang="scss" scoped>
.chkService {
  position: absolute;
  top: 5px;
  left: 5px;
}
.chkDisabled {
  position: absolute;
  top: 30px;
  left: 5px;
  label:before {
    content: "";
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 100%;
    background: $color-white url('~@/assets/img/ico_disabled_off.png') 50% 50% / contain no-repeat;
    opacity: 0.5;
    cursor: pointer;
  }
  :checked + label:before {
    background-image: url('~@/assets/img/ico_disabled_on.png');
    opacity: 1;
  }
}
.btnTranslation {
  width: 30px;
  svg {
    width: 24px;
    height: 24px;
  }
  &:hover svg {
    width: 26px;
    height: 26px;
  }
}
.btnDel {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  padding: 6px;
  font-size: 0;
  border-radius: 0 4px 0 0;
  background-color: rgba($color-white, 0.5);
}
.btnCopy {
  position: absolute;
  top: 166px;
  left: 4px;
  width: 36px;
  height: 36px;
  padding: 6px;
  font-size: 0;
  border-radius: 4px;
  border: 1px solid $color-lgrey2;
  background-color: rgba($color-white, 0.75);
  box-shadow: 0 0 5px rgba($color-dark, 0.15);
  img {
    opacity: 0.3;
  }
  &:hover {
    border-color: $color-lgrey;
    img {
      opacity: 0.75;
    }
    &:before {
      content: "Duplicate";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-bottom: 6px;
      padding: 0 6px;
      color: $color-white;
      font-size: 12px;
      border-radius: 4px;
      background-color: $color-dark;
      transform: translateX(-50%);
    }
    &:after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      width: 5px;
      height: 5px;
      margin-bottom: 3px;
      transform: translateX(-50%) rotate(45deg);
      background-color: $color-dark;
    }
  }
}
.thumbBtns {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  white-space: nowrap;
  z-index: 1;
  transform: translate(-50%, -50%);
  .thumbBtn {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin: 0 5px;
    padding: 7px;
    border: 1px solid $color-lgrey;
    border-radius: 100%;
    background-color: $bg-default;
    opacity: 0.8;
    cursor: pointer;
    img {
      width: 24px;
      cursor: pointer;
    }
    &:hover {
      opacity: 1;
    }
  }
}
.thumb:hover .thumbBtns {
  display: block;
}
.ratioBtns {
  display: none;
  position: absolute;
  top: 30px;
  right: 5px;
  white-space: nowrap;
  font-size: 0;
  overflow: hidden;
  z-index: 1;
  .ratioBtn {
    width: 36px;
    height: 28px;
    background-size: auto 28px;
    & + .ratioBtn {
      margin-top: 2px;
      margin-left: 0;
    }
  }
}
.thumb:hover .ratioBtns {
  display: block;
}
.productState {
  padding: 5px 5px 0;
  text-align: center;
  font-size: 0.85em;
  border-top: 1px solid $color-lgrey2;
  .stateItem {
    display: inline-block;
    margin: 0 2px 4px;
    padding: 0 4px;
    color: $color-grey;
    vertical-align: top;
    white-space: nowrap;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
  }
  .disabled {
    color: $color-red;
    border-color: rgba($color-red, 0.5);
    background-color: rgba($color-red, 0.15);
  }
}
.availableLayer {
  .inner {
    width: auto;
  }
}
.validateMessage {
  position: relative;
  margin-top: 3px;
  padding: 5px;
  font-size: 12px;
  color: $color-red;
  border-radius: 2px;
  background-color: $color-lgrey2;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 15px;
    width: 6px;
    height: 6px;
    margin-top: -3px;
    background-color: $color-lgrey2;
    transform: rotate(45deg);
  }
}
.btnSetManageProduct {
  margin-top: 5px;
  .notManaged {
    text-decoration: line-through;
  }
}
.pluBox {
  display: flex;
  .input {
    flex: 1;
    width: auto;
  }
  .btnPlu {
    position: relative;
    align-self: stretch;
    width: 32px;
    margin-left: 2px;
    padding-top: 16px;
    font-size: 10px;
    color: $color-dark;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &:before {
      content: "";
      position: absolute;
      top: 6px;
      left: 0;
      width: 100%;
      height: 12px;
      background: url('~@/assets/img/ico_pricelabel.png') 50% 50% / contain no-repeat;
      opacity: 0.5;
    }
  }
}
</style>
